import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class LocationService {

  geolocation_coords: any;
  constructor() { }
  getCurrentLocation() {
    return new Promise((resolve, reject) => {
      if (navigator.geolocation) {
        navigator.geolocation.getCurrentPosition(
          (position) => {
            if (position) {
              let lat = position.coords.latitude;
              let lng = position.coords.longitude;
              const location = {
                lat,
                lng,
              };
              this.geolocation_coords = location;
              resolve(location);
            } else {
              reject('User denied Geolocation');
            }
          },
          (error) => {
            reject('User denied Geolocation');
            console.log(error)
          }
        );
      } else {
        reject('Geolocation is not supported by this browser.');
      }
    });
  }
}
